import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-popup-grid',
  templateUrl: './popup-grid.component.html',
  styleUrls: ['./popup-grid.component.scss']
})
export class PopupGridComponent implements OnInit {
  @Input() stats: any = {};

  constructor() { }

  ngOnInit() {
  }

}
